import {
  IBusInternalTokenExternal,
  IBusInternalTokenInternal,
  ICertillion,
  ICompanyDigitalCertificate,
  ISI_PNI,
} from "./models";

const U_BUS = {
  code: 1,
  defaultValues: {
    uBusUserExternal: false,
    busInternalToken: null,
    token: null,
    host: null,
  },
};

const SI_PNI = {
  code: 2,
  defaultValues: {
    authUrl: "",
    baseUrl: "",
    responsibleDocument: "",
    companyDigitalCertificate: null,
  },
};

const CERTILLION = {
  code: 3,
  defaultValues: {
    isCertillionCloud: false,
    authorizeLocal: false,
    baseUrl: "",
    baseUrlProxy: "",
    clientId: "",
    clientSecret: "",
    pscsAccountsPath: "",
    tokenPath: "",
    hasTokenPath: "",
    uploadFilePath: "",
    signaturePath: "",
    signatureStandardOptions: "",
    signatureHorizontalX: "",
    signatureHorizontalY: "",
    signatureVerticalX: "",
    signatureVerticalY: "",
    companyDigitalCertificate: null,
  },
};

const GER_ACESSO = {
  code: 4,
  defaultValues: {
    token: "",
    baseUrl: "",
  },
};

const PLUG_NOTAS = {
  code: 5,
  defaultValues: {
    baseUrl: "",
    token: "",
    defaultProviderDocument: "",
  },
};

const SHIFT_LIS = {
  code: 6,
  defaultValues: {},
};

const PROTHEUS = {
  code: 7,
  defaultValues: {},
};

const SGU = {
  code: 8,
  defaultValues: {},
};

const jsonParser = <T,>(json: string | null | undefined) => {
  if (!json || json.trim() === "") return null;

  try {
    const configs: T = JSON.parse(json);

    return configs;
  } catch (error) {
    console.error("Erro ao realizar parse do JSON:", error);
  }
  return null;
};

const certillionParser = (
  json: string | null | undefined,
  companyDigitalCertificate?: ICompanyDigitalCertificate,
) => {
  const configs = jsonParser<ICertillion>(json);

  const parseOptionalString = (value?: number | string | null) => {
    if (value === null || value === undefined) return "";

    return value.toString();
  };

  if (configs) {
    return {
      isCertillionCloud: configs.isCertillionCloud ?? false,
      authorizeLocal: configs.authorizeLocal ?? false,
      baseUrl: configs.baseUrl,
      baseUrlProxy: configs.baseUrlProxy ?? "",
      clientId: configs.clientId,
      clientSecret: configs.clientSecret,
      signatureStandardOptions: configs.signatureStandardOptions,
      signatureHorizontalX: parseOptionalString(configs.signatureHorizontalX),
      signatureHorizontalY: parseOptionalString(configs.signatureHorizontalY),
      signatureVerticalX: parseOptionalString(configs.signatureVerticalX),
      signatureVerticalY: parseOptionalString(configs.signatureVerticalY),
      companyDigitalCertificate: companyDigitalCertificate || null,
    };
  }
};

const iServiceTypeNameGet = (iServiceTypeCode: number) => {
  switch (iServiceTypeCode) {
    case U_BUS.code:
      return "busInternalToken";
    case SI_PNI.code:
      return "si_pni";
    case GER_ACESSO.code:
      return "gerAcesso";
    case CERTILLION.code:
      return "certillion";
    case PLUG_NOTAS.code:
      return "plugNotas";
    case SHIFT_LIS.code:
      return "shiftLis";
    case PROTHEUS.code:
      return "protheus";
    case SGU.code:
      return "sgu";
    default:
      return null;
  }
};

const busInternalTokenGet = (
  busInternalToken?:
    | IBusInternalTokenInternal
    | IBusInternalTokenExternal
    | null,
  uBusUserExternal?: boolean | null,
) => {
  return (
    busInternalToken && {
      ...busInternalToken,
      uBusUserExternal: uBusUserExternal ?? false,
    }
  );
};

const si_pniParser = (
  json: string | null | undefined,
  companyDigitalCertificate: ICompanyDigitalCertificate,
) => {
  const configs = jsonParser<ISI_PNI>(json);

  if (configs) {
    return {
      ...configs,
      companyDigitalCertificate: companyDigitalCertificate,
    };
  }

  return null;
};

export const useIServiceType = () => {
  return {
    jsonParser,
    iServiceTypeNameGet,
    busInternalTokenGet,
    si_pniParser,
    certillionParser,
    uBusValues: U_BUS,
    si_pniValues: SI_PNI,
    certillionValues: CERTILLION,
    gerAcessoValues: GER_ACESSO,
    plugNotasValues: PLUG_NOTAS,
    shiftLisValues: SHIFT_LIS,
    protheusValues: PROTHEUS,
    sguValues: SGU,
  };
};
